import type { RuleObject } from "antd/es/form";
import type { StoreValue } from "antd/es/form/interface";
import { t } from 'i18next';

export const currencyStepMap: Record<string, number> = {
    IQD: 250,
    USD: 5,
    AED: 1,
    SAR: 1,
    EUR: 1,
    // Add more currencies here...
};

export const multipleOfValidator = (
    multiple: number,
    message?: string
) => ({
    validator(_: RuleObject, value: StoreValue) {
        if (value == null || value === "") {
            return Promise.resolve();
        }

        if (Number(value) % multiple === 0) {
            return Promise.resolve();
        }

        return Promise.reject(
            new Error(
                message || t('multipleOf', { multiple })
            )
        );
    },
});

// CURRENCY AMOUNT VALIDATOR

export const currencyAmountValidator = (
    currencyISOCode?: string,
    message?: string
) => {
    const step = currencyStepMap[currencyISOCode || "IQD"] ?? 1;

    return {
        validator(_: RuleObject, value: StoreValue) {
            if (value == null || value === "") {
                return Promise.resolve();
            }

            if (Number(value) % step === 0) {
                return Promise.resolve();
            }

            return Promise.reject(
                new Error(
                    message || t('amountMustFollowCurrencyRules', { step })
                )
            );
        },
    };
};